import Link from 'next/link';

const DraftModeBanner = () => {
  return (
    <div className="flex items-center justify-center border-b-2 border-white bg-black py-2 text-center text-white">
      <h1 className="mr-4">Preview Mode</h1>
      <Link
        href="/api/preview/end-session"
        prefetch={false}
        className="inline-block rounded border-2 border-white px-2 py-1 text-sm uppercase text-white hover:underline"
      >
        Stop previewing
      </Link>
    </div>
  );
};

export default DraftModeBanner;
